import CryptoJS from 'crypto-js'
import store from "@/store"

//sha256加密
const SHA256 = function(text){
    var sha256 = CryptoJS.SHA256(text);
    return sha256.toString(CryptoJS.enc.Base64);
}
//加密
function TripleDESEncrypt(text, key, iv){
    key  = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);
    var encryptText = CryptoJS.TripleDES.encrypt(JSON.stringify(text), key, { 
        iv: iv, 
        mode: CryptoJS.mode.CBC,  
        padding: CryptoJS.pad.Pkcs7  
    })
    return encryptText.ciphertext.toString(CryptoJS.enc.Base64);
}
//解密
function TripleDESDecrypt(text, key, iv){
    key  = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);
    var digestText = CryptoJS.TripleDES.decrypt({
        ciphertext:CryptoJS.enc.Base64.parse(text)
    }, key, { 
        iv: iv, 
        mode: CryptoJS.mode.CBC,  
        padding: CryptoJS.pad.Pkcs7  
    })
    return JSON.parse(digestText.toString(CryptoJS.enc.Utf8));
}
//请求加密
const RequestEncrypt = function(parameters,Timestamp){
    if(!parameters){
        return "";
    }else if(parameters instanceof Object){
        var obj = {};
        for(var key in parameters){
            if(key.indexOf("_") > -1 && parameters[key]){
                let msg = TripleDESEncrypt(parameters[key],store.state.AppInfo.RequestEncryptKey,Timestamp.toString().substr(2));
                obj[key] = msg;
            }else if(parameters[key] instanceof Object){
                obj[key] = RequestEncrypt(parameters[key],Timestamp);
            }else{
                obj[key] = parameters[key];
            }
        }
        return obj;
    }else {
        var msg = TripleDESEncrypt(parameters,store.state.AppInfo.RequestEncryptKey,Timestamp.toString().substr(2))
        return msg;
    }
}
//响应解密
const ResponseDecrypt = function(parameters,Timestamp){
    if(!parameters){
        return "";
    }else if(parameters instanceof Object){
        var obj = {};
        for(var key in parameters){
            if(key.indexOf("_") > -1 && parameters[key]){
                let msg = TripleDESDecrypt(parameters[key],store.state.AppInfo.ResponseEncryptKey,Timestamp.toString().substr(2));
                obj[key] = msg;
            }else if(parameters[key] instanceof Object){
                obj[key] = ResponseDecrypt(parameters[key],Timestamp);
            }else{
                obj[key] = parameters[key];
            }
        }
        return obj;
    }else {
        var msg = TripleDESDecrypt(parameters.toString(),store.state.AppInfo.ResponseEncryptKey,Timestamp.toString().substr(2))
        return msg;
    }
}

export default{
    SHA256,
    RequestEncrypt,
    ResponseDecrypt
}